module.exports = __webpack_public_path__ + "assets/img/ic-member.763f8733.svg";